import { cn } from "cn";
import { useTheme } from "next-themes";
import type { ComponentType, SVGProps } from "react";

interface ThemeIconProps extends SVGProps<SVGSVGElement> {
  lightIcon: ComponentType<SVGProps<SVGSVGElement>>;
  darkIcon: ComponentType<SVGProps<SVGSVGElement>>;
  size?: number;
  className?: string;
}

export default function ThemeIcon({
  lightIcon: LightIcon,
  darkIcon: DarkIcon,
  className,
  ...props
}: ThemeIconProps) {
  const { resolvedTheme } = useTheme();
  const Icon = resolvedTheme === "dark" ? DarkIcon : LightIcon;

  return <Icon className={cn("shrink-0", className)} {...props} />;
}
